import React, { useState, useEffect } from 'react';
import ReactConfetti from 'react-confetti';


// Define the types for the component's props
interface ModalProps {
  isOpen: boolean;
  onClose: () => void; // onClose is a function that returns nothing (void)
  children: React.ReactNode; // children can be any renderable React content
}

// A simple Modal component
const Modal = ({ isOpen, onClose, children }: ModalProps) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        position: 'relative',
        zIndex: 1001
      }}>
        {children}
        <button onClick={onClose} style={{ marginTop: '10px' }}>Close</button>
      </div>
    </div>
  );
};

// Main application component
const ConfettiModalWidget = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // State to control the confetti
  const [showConfetti, setShowConfetti] = useState(false);

  const handleButtonClick = () => {
    // Close the modal
    setIsModalOpen(false);
    // Trigger the confetti
    setShowConfetti(true);

    // Stop the confetti after a few seconds (e.g., 5 seconds)
    setTimeout(() => {
      setShowConfetti(false);
    }, 5000);
  };

  return (
    <div>
      <button onClick={() => setIsModalOpen(true)}>Open Modal</button>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2>Congratulations!</h2>
        <p>You did it! Click the button below for a surprise.</p>
        <button onClick={handleButtonClick}>Claim Reward</button>
      </Modal>

      {/* Confetti component - only renders when showConfetti is true */}
      {showConfetti && (

            <ReactConfetti
            drawShape={ctx => {
                ctx.beginPath();
                ctx.arc(0, 0, ctx.canvas.width / 250, 0, 2 * Math.PI); 
                ctx.fill();}}
            recycle={false} // Confetti runs once
            numberOfPieces={1000}
            tweenDuration={2000}
            gravity={0.15}
            width={window.innerWidth}
            height={window.innerHeight}
            colors={['#81cae0ff', '#c0ebedff', '#0000ff', '#4b656cff']} //
            />

      )}
    </div>
  );
};

export default ConfettiModalWidget;

